<template>
  <base-card collapsible closed handler="collapseProjectCreditPaper" hide-caret>
    <template v-slot:header>
      <base-card-heading>
        Credit Paper
      </base-card-heading>
      <base-button
        collapse="#collapseProjectCreditPaper"
        controls="collapseProjectCreditPaper"
        secondary
        small>
        View &amp; Edit
      </base-button>
    </template>
    <div class="card-deck">
      <base-card mb="0">
        <template v-slot:header>
          <base-card-heading>
            Initial Credit Paper
          </base-card-heading>
        </template>
        <dl class="row mb-0">
          <dt class="col-sm-4">Last Edit</dt>
          <dd class="col-sm-8">Pending</dd>
          <dt class="col-sm-4">Date Submitted</dt>
          <dd class="col-sm-8">
            <base-button
              :to="{ name: 'projects.credit-paper', id: project._id }"
              small
              secondary>
              Submit
            </base-button>
          </dd>
          <dt class="col-sm-4">Date Approved</dt>
          <dd class="col-sm-8">Pending</dd>
        </dl>
      </base-card>
      <base-card mb="0">
        <template v-slot:header>
          <base-card-heading>
            Final Credit Paper
          </base-card-heading>
        </template>
        <dl class="row mb-0">
          <dt class="col-sm-4">Last Edit</dt>
          <dd class="col-sm-8">Pending</dd>
          <dt class="col-sm-4">Date Submitted</dt>
          <dd class="col-sm-8">Pending</dd>
          <dt class="col-sm-4">Date Approved</dt>
          <dd class="col-sm-8">Pending</dd>
        </dl>
      </base-card>
    </div>
  </base-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProjectCreditPaper',

  computed: {
    ...mapState({
      project: store => store.core.projects.entity
    })
  }
}
</script>
